import { roundsState } from './roundsSlice';

export const initialState: roundsState = {
  loading: 'idle',
  data: [],
};
